/*
** qeConsts - quantum engine constants shared js ⇆  C++
** this file generated Sun Sep 27 2026 21:44:46 GMT-0700 (Pacific Daylight Time)
** by the file quantumEngine/building/genExports.js
*/

const qeConsts = {};
	qeConsts.contDISCRETE = 0;
	qeConsts.contWELL = 1;
	qeConsts.contENDLESS = 2;
	qeConsts.ERROR_RADIUS = 1e-12;
	qeConsts.grSENTINEL_VALUE = 123;
	qeConsts.MAX_LABEL_LEN = 31;
Object.freeze(qeConsts);
export default qeConsts;
